export default function(arg, type, extra = 2) {
    if (isNaN(new Number(arg)) || arg === null) {
        return '';
    }
    //1转换成百分比表示
    if (type == 1) {
        return (new Number(arg) * 100).toFixed(1) + '%'
    } else if (type == 2) {
        //2保留小数extra位
        return new Number(arg).toFixed(extra)
    } else if (type == 3) {
        //3保留小数extra位,返回Number格式
        return parseFloat(new Number(arg).toFixed(extra));
    }


}
